export const exportType = {
    DWG: { value: 1, label: 'DWG' },
    PNG: { value: 2, label: 'PNG' },
    JPG: { value: 3, label: 'JPG' },
}